$(document).ready(function () {
  if($('.soigneurs').length > 0) {
    const carouselS = document.querySelector('.carousel-soigneur')
    if (carouselS) {
      new Glider(carouselS, {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        draggable: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      })
    }
  }
});
